import React from "react";
import clsx from "clsx";
import Button from "components/common_components/Button";
import Card from "components/common_components/Card";
import Icon from "components/common_components/Icon";
import PropTypes from "prop-types";
import Status from "components/common_components/Status";

const ClientSummary = ({ client, visible, onBackClick }) => {
    return (
        <div
            className={clsx("layout client-summary-container", {
                visible: visible,
                invisible: !visible,
            })}
        >
            {visible && client && (
                <>
                    <h3>Client</h3>
                    <Card>
                        <div>
                            <span>{client?.fullName}</span>
                            <Status id={client?.enabled ? "active" : "inactive"} withIcon />
                        </div>
                        <Button secondary link onClick={onBackClick}>
                            <Icon name="cancel" color="secondary" size="xs" />
                        </Button>
                    </Card>
                </>
            )}
        </div>
    );
};

ClientSummary.propTypes = {
    client: PropTypes.object,
    visible: PropTypes.bool,
    onBackClick: PropTypes.func,
};

ClientSummary.defaultProps = {
    client: undefined,
    visible: true,
    onBackClick: () => {},
};

export default ClientSummary;
